import { UnknownObject } from '../models/unknown-object.model';

export function isObject(value: unknown): value is UnknownObject {
  return value !== null && typeof value === 'object';
}

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}
